<ng-container *ngIf="text?.length">
      <span [attr.data-cy]="'contact-box-line-' + dataCy"
            [class.bold]="bold"
      >
        <ng-container *ngIf="!noLabel">
          <span [class.bold]="labelBold">{{ 'shared.' + tag | cxTranslate }} : </span>
        </ng-container>
        <ng-container *ngIf="inputType === 'text' || inputType === 'noLabel' then textContent else link"></ng-container>
      </span>
  <br>
</ng-container>
<ng-template #link>
  <mb-link [linkData]="{ url: value || text , uid: cmsLinkType, text: text }"
           target="_blank"
  ></mb-link>

</ng-template>
<ng-template #textContent>{{ text }}</ng-template>
